export const data = [
  'changeNotification',
  'accountHacked',
  'cantFindInterestingJobs',
  'madeAnotherAccount',
  'dontLikeWebsite',
  'privacyConcern',
  'other'
]
